import dataController from '@/lib/dataController';
import model from '@/models/user';
import AppPage from '@/ui/AppPage/AppPage';
import { Box } from '@mui/material';
import * as React from 'react';
import { useParams } from 'react-router';
import { Permissions } from "@/lib/permissions";
import menuRoutes from '@/routes/menu';
import UserForm from './UserForm';
import DialogProvider from '@/ui/DialogContext/DialogProvider';


function UserPage() {
  const { user_id } = useParams();
  const dc = new dataController(model);

  const recordId = parseInt(user_id ? user_id : '', 10);

  return (
    <DialogProvider>
      <AppPage menu={menuRoutes} needPermission={[Permissions.Administration]}>
        <Box m={2}>
          <UserForm dc={dc} recordId={recordId} mode="update" form="update" />
        </Box>
      </AppPage>
    </DialogProvider>
  );
}

export default UserPage;